import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import { userAccreditedInvestorQuestionnaireUrl } from '@buyside/util/urlHelper';

const UserAccreditedInvestorProfileForm: React.FC = () => (
  <div>
    Go to <Link to={userAccreditedInvestorQuestionnaireUrl()}>Accreditation Questionnaire</Link> to
    create or edit your information.
  </div>
);

export default UserAccreditedInvestorProfileForm;
